import { render, staticRenderFns } from "./OtherConfig.vue?vue&type=template&id=731eaa5e&scoped=true&"
import script from "./OtherConfig.vue?vue&type=script&lang=js&"
export * from "./OtherConfig.vue?vue&type=script&lang=js&"
import style0 from "./OtherConfig.vue?vue&type=style&index=0&id=731eaa5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731eaa5e",
  null
  
)

export default component.exports